import { useEffect, useState } from "react"
import "./ProfilePage.css"
import Navbar from "../../components/Navbar"
import Footer from "../../components/Footer"
import { useApi } from "../../hooks/useApi"
import profilePic from "../../assets/images/student.jpg"
import uploadIcon from "../../assets/images/uploadIcon.png"
import listeningBadge from "../../assets/images/listening.png"
import speakingBadge from "../../assets/images/speaking.jpg"
import writingBadge from "../../assets/images/writing.png"
import readingBadge from "../../assets/images/reading.jpg"
import badge1 from "../../assets/images/badge1.png"
import badge2 from "../../assets/images/badge2.png"
import badge3 from "../../assets/images/badge3.png"
import badge4 from "../../assets/images/badge4.png"

const ProfilePage = () => {
  const [userphoto, setUserPhoto] = useState(profilePic)
  const [upload, setUpload] = useState(uploadIcon)
  const [badges, setBadges] = useState({
    listening: null,
    speaking: null,
    writing: null,
    reading: null,
  })
  const [lessonTotals, setLessonTotals] = useState({
    SD_total: 0,
    QA_total: 0,
    ST_total: 0,
    CE_total: 0,
    PD_total: 0,
    CM_total: 0,
  })
  const [user, setUser] = useState({})

  const userID = localStorage.getItem("user")
  const { fetchData, isLoading, error } = useApi()

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const userData = await fetchData(`/profile/${userID}`)
        setUser(userData)

        const lessonData = await Promise.all([
          fetchData("/lessons/listening/sentence-dictation"),
          fetchData("/lessons/listening/qa"),
          fetchData("/lessons/speaking/storytelling"),
          fetchData("/lessons/speaking/conversation-exchange"),
          fetchData("/lessons/writing/picturedescription"),
          fetchData("/lessons/reading/comprehension"),
        ])

        setLessonTotals({
          SD_total: lessonData[0].lessons.length,
          QA_total: lessonData[1].lessons.length,
          ST_total: lessonData[2].lessons.length,
          CE_total: lessonData[3].lessons.length,
          PD_total: lessonData[4].lessons.length,
          CM_total: lessonData[5].lessons.length,
        })

        setBadges({
          listening: userData.listening >= 0 ? listeningBadge : null,
          speaking: userData.speaking >= 0 ? speakingBadge : null,
          writing: userData.writing >= 0 ? writingBadge : null,
          reading: userData.reading >= 0 ? readingBadge : null,
        })
      } catch (error) {
        console.error("Error fetching profile data:", error)
      }
    }

    fetchProfileData()
  }, [userID, fetchData])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error) {
    return <div>Error: {error.message}</div>
  }

  return (
    <div className="container-profilepage">
      <Navbar />
      <div className="container-profilepage-user">
        <div className="userdetails-main">
          <div className="userdetails">
            <h1 className="userdetails-text">{user.fullName}</h1>
            <h4 className="userdetails-text">{user.userID}</h4>
            <h2 className="userdetails-text">{user.school}</h2>
            <h3 className="userdetails-text"> Class: {user.class}</h3>
            <h3 className="userdetails-text">Section: {user.section}</h3>
          </div>
          <div className="userphoto">
            <img className="userphoto-image" src={userphoto || "/placeholder.svg"} alt="User profile" />
          </div>
          <div className="photoUploadButton">
            <a href="#">
              <img className="userphoto-uploadImage" src={upload || "/placeholder.svg"} alt="Upload" />
            </a>
          </div>
        </div>
      </div>
      <div className="container-profilepage-achievements">
        {badges.listening && (
          <div className="achievements-firstAchievement">
            <img className="achievements-image" src={badges.listening || "/placeholder.svg"} alt="Listening badge" />
          </div>
        )}
        {badges.speaking && (
          <div className="achievements-secondAchievement">
            <img className="achievements-image" src={badges.speaking || "/placeholder.svg"} alt="Speaking badge" />
          </div>
        )}
        {badges.writing && (
          <div className="achievements-thirdAchievement">
            <img className="achievements-image" src={badges.writing || "/placeholder.svg"} alt="Writing badge" />
          </div>
        )}
        {badges.reading && (
          <div className="achievements-fourthAchievement">
            <img className="achievements-image" src={badges.reading || "/placeholder.svg"} alt="Reading badge" />
          </div>
        )}
      </div>
      <div className="container-profilepage-stats">
        <div className="profilepage-stats-achievements">
          <div className="stats-header">
            <h1 className="stats-headerText">Stats</h1>
          </div>
          <div className="lessonsCompletion-stats">
            <div className="lessionsCompletion-stats-lessons">
              <h3 className="stats-text">Sentence Dictations:</h3>
              <h3 className="stats-text">Question and Answer:</h3>
              <h3 className="stats-text">Storytelling:</h3>
              <h3 className="stats-text">Conversation Exchange:</h3>
              <h3 className="stats-text">Picture Description:</h3>
              <h3 className="stats-text">Comprehension:</h3>
            </div>
            <div className="lessonsCompletion-num">
              <h3 className="stats-text">
                {user.sentence_dictation}/{lessonTotals.SD_total}
              </h3>
              <h3 className="stats-text">
                {user.question_answer}/{lessonTotals.QA_total}
              </h3>
              <h3 className="stats-text">
                {user.storytelling}/{lessonTotals.ST_total}
              </h3>
              <h3 className="stats-text">
                {user.conversation_exchange}/{lessonTotals.CE_total}
              </h3>
              <h3 className="stats-text">
                {user.picture_description}/{lessonTotals.PD_total}
              </h3>
              <h3 className="stats-text">
                {user.comprehension}/{lessonTotals.CM_total}
              </h3>
            </div>
          </div>
        </div>
        <div className="profilepage-stats-achievements">
          <div className="achievements-header">
            <h1 className="stats-headerText">Achievements</h1>
          </div>
          <div className="profilepage-achievements">
            <img className="stats-achievements-image" src={badge1 || "/placeholder.svg"} alt="Achievement 1" />
            <img className="stats-achievements-image" src={badge2 || "/placeholder.svg"} alt="Achievement 2" />
            <img className="stats-achievements-image" src={badge3 || "/placeholder.svg"} alt="Achievement 3" />
            <img className="stats-achievements-image" src={badge4 || "/placeholder.svg"} alt="Achievement 4" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ProfilePage

